import { apiClient } from "../utils/api";

export type OrganizerCautionPhrase = {
	id: number;
	content: string;
	usage_count: number;
};

export type OrganizerCautionSetItem = {
	id: number;
	content: string;
	position: number;
};

export type OrganizerCautionSet = {
	id: number;
	name: string;
	description?: string | null;
	items: OrganizerCautionSetItem[];
};

export type OrganizerCautionSetPayload = {
	name: string;
	description?: string | null;
	items: { content: string }[];
};

export const fetchCautionSuggestions = async (): Promise<OrganizerCautionPhrase[]> => {
	const { data } = await apiClient.get<{ phrases: OrganizerCautionPhrase[] }>(
		"/organizer/cautions/suggestions"
	);
	return data?.phrases ?? [];
};

export const fetchCautionSets = async (): Promise<OrganizerCautionSet[]> => {
	const { data } = await apiClient.get<{ sets: OrganizerCautionSet[] }>(
		"/organizer/cautions/sets"
	);
	return data?.sets ?? [];
};

export const createCautionSet = async (
	payload: OrganizerCautionSetPayload
): Promise<OrganizerCautionSet> => {
	const { data } = await apiClient.post<{ set: OrganizerCautionSet }>(
		"/organizer/cautions/sets",
		payload
	);
	return data.set;
};

export const updateCautionSet = async (
	id: number,
	payload: OrganizerCautionSetPayload
): Promise<OrganizerCautionSet> => {
	const { data } = await apiClient.put<{ set: OrganizerCautionSet }>(
		`/organizer/cautions/sets/${id}`,
		payload
	);
	return data.set;
};

export const deleteCautionSet = async (id: number): Promise<void> => {
	await apiClient.delete(`/organizer/cautions/sets/${id}`);
};
